import { csx } from '@vtex/admin-ui'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { RecommendationProductsItem } from './RecommendationProductsItem'
import { RecommendationProduct } from '@/checkout-instore-legacy/product/typings'
import {
  ProductCarousel,
  ProductCarouselList,
  ProductCarouselTitle,
} from '@/checkout-instore-legacy/components/ProductCarousel'

export type RecommendationProductsTemplateProps = {
  productsList: RecommendationProduct[]
  onProductClick: (product: RecommendationProduct) => void
}

export const RecommendationProductsTemplate = ({
  productsList,
  onProductClick,
}: RecommendationProductsTemplateProps) => {
  const handleProductClick = (product: RecommendationProduct) => () => {
    onProductClick(product)
  }

  return (
    <div
      className={csx({
        background: '$white',
        paddingY: '$space-8',
      })}
    >
      <ProductCarousel
        className={csx({
          maxWidth: '96rem',
          marginX: 'auto',
        })}
      >
        <ProductCarouselTitle>
          <FormattedMessage id="cart.products-similar-section.title" />
        </ProductCarouselTitle>
        <ProductCarouselList mobileCardSize="11rem" desktopProductsPerPage={5}>
          {productsList.map((product) => (
            <RecommendationProductsItem
              key={`${product.id}-${product.skuId}`}
              product={product}
              handleProductClick={handleProductClick(product)}
            />
          ))}
        </ProductCarouselList>
      </ProductCarousel>
    </div>
  )
}
